import { render, staticRenderFns } from "./FImage.vue?vue&type=template&id=3938f9f4&scoped=true&"
import script from "./FImage.vue?vue&type=script&lang=js&"
export * from "./FImage.vue?vue&type=script&lang=js&"
import style0 from "./FImage.vue?vue&type=style&index=0&id=3938f9f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938f9f4",
  null
  
)

export default component.exports